<template>
  <div @contextmenu.prevent @keydown="disableConsole">
    <router-view />
  </div>
</template>

<script>
// export default {
//   name: 'App',
//   // 禁止打开控制台功能
//   methods: {
//     disableConsole(event) {
//       // 只阻止特定的开发者工具快捷键
//       if (
//         event.key === 'F2' ||
//         (event.ctrlKey && event.shiftKey && event.key === 'I') ||
//         (event.ctrlKey && event.shiftKey && event.key === 'J') ||
//         (event.ctrlKey && event.key === 'U')
//       ) {
//         event.preventDefault()
//         event.stopPropagation()
//       }
//       // 不阻止其他键盘事件，让输入框正常工作
//     },
//   },
//   mounted() {
//     document.addEventListener('keydown', this.disableConsole)
//   },
//   beforeUnmount() {
//     document.removeEventListener('keydown', this.disableConsole)
//   },
// }
//{ "Action":"SwitchWebcast", "Data":"{ \"UserName\":\"diybyholly\",\"key\":\"123456\" }" }
</script>

<style>
#app {
  font-family:
    'Segoe UI',
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'PingFang SC',
    'Microsoft YaHei',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--star-text, #0f172a);
  min-height: 100vh;
}

* {
  margin: 0;
  padding: 0;
}

body {
  min-width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  -moz-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

/* 允许输入框和文本区域进行文本选择和输入 */
input,
textarea {
  -moz-user-select: text !important;
  -khtml-user-select: text !important;
  user-select: text !important;
}
</style>
